<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-header">
        <h5 class="text-center">EDITAR EMPRESA</h5>
      </div>
      <div class="container mb-3">
          <div class="card">
           
              <div class="card-body">   
              <div class="row">
                <div class="col-md-4">

                  <div class="row form-group">
                    <div class="col-12 col-md-12">
                      <label class="font-weight-bold mr-1">Razón Social:</label>
                      <span
                        class="text-danger text-help"
                        v-if="!$v.empresa.emp_razon_social.required"
                        ><small>Campo requerido</small>
                      </span>
                      <input
                        type="text"
                        placeholder="Ej.: Hotel Girasoles"
                        class="form form-control"
                        :class="{'is-invalid': $v.empresa.emp_razon_social.$error}"
                        v-model.trim="empresa.emp_razon_social"
                        @keyup="empresa.emp_razon_social = empresa.emp_razon_social.toUpperCase()"
                      />
                   </div> 
                  </div>
              
                  <div class="row form-group">  
                    <div class="col-12 col-md-12" >
                      <label class="font-weight-bold mr-1">Nit:</label>
                        <span
                          class="text-danger text-help"
                          v-if="!$v.empresa.emp_nit.required"
                          ><small>Campo requerido</small>
                        </span>
                        <input
                          type="number"
                          placeholder="Ej.: 82938445"
                          class="form form-control"
                          :class="{'is-invalid':$v.empresa.emp_nit.$error }"
                          v-model="empresa.emp_nit"
                        />
                    </div>
                  </div>
                  <div class="row form-group">  
                    <div class="col-12 col-md-12" >
                       <label class="font-weight-bold mr-1">Licencia Funcionamiento:</label>
                          <span
                            class="text-danger text-help"
                            v-if="!$v.empresa.emp_licencia.required"
                            ><small>Campo requerido</small>
                          </span>
                          <input
                            type="number"
                            
                            placeholder="Ej.: 82938445"
                            class="form form-control"
                            :class="{'is-invalid':$v.empresa.emp_licencia.$error}"
                            v-model="empresa.emp_licencia"/>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-12 col-md-12">
                      <label class="font-weight-bold mr-1">Teléfono:</label>
                        <span
                          class="text-danger text-help"
                          v-if="!$v.empresa.emp_telefono.required"
                          ><small>Campo requerido</small>
                        </span>
                        <input
                          type="number"
                          placeholder="Ej.: 82938445"
                          class="form form-control"
                          :class="{'is-invalid':$v.empresa.emp_telefono.$error}"
                          v-model="empresa.emp_telefono"/>
                    </div>
                  </div>
                  <div class="row form-group">
                     <div class="col-12 col-md-12">
                      <label class="font-weight-bold mr-1">Rubro:</label>
                      <span
                        class="text-danger text-help"
                        v-if="!$v.empresa.id_rubro.required"
                        ><small>Campo requerido</small>
                      </span>
                      <select
                        class="custom-select"
                        :class="{ 'is-invalid':$v.empresa.id_rubro.$error }"
                        v-model="empresa.id_rubro"
                      >
                        <option
                          v-for="t in rubros"
                          :value="t.id_rubro"
                          :key="t.rubro_descripcion"
                          >{{ t.rubro_descripcion }}</option
                        >
                      </select>
                    </div>     
                  </div>
                  <div class="row form-group">
                       <div class="col-12 col-md-12">
                          <label class="font-weight-bold mr-1"> Tipo Servicio: </label>
                          <span
                            class="text-danger text-help"
                            v-if="!$v.empresa.tipo_servicio.required"
                            ><small>Campo requerido</small>
                          </span>
                          <select 
                            class="form form-control"
                            :class="{ 'is-invalid':$v.empresa.tipo_servicio.$error }"
                            v-model="empresa.tipo_servicio"
                          >
                            <option value="SERVICIO">SERVICIOS BRINDADOS</option>
                            <option value="CONTRATO">PERSONAL CONTRATADO</option>
                          </select>
                        </div>
                  </div>
                </div>

                <div class="col-md-8">
                 <div class="row form-group">
                    <div class="col-12 col-md-4">
                      <label class="font-weight-bold mr-1">Departamento:</label>
                        <span
                          class="text-danger text-help"
                          :class="{'is-invalid': $v.empresa.codigo_departamento.$error}"
                          v-if="!$v.empresa.codigo_departamento.required"
                          ><small>Requerido</small>
                        </span>
                        <select
                          class="custom-select"
                          :class="{'is-invalid':$v.empresa.codigo_departamento.$error}"
                          v-model="empresa.codigo_departamento"
                          @change="getMunicipios(empresa.codigo_departamento)"
                        >
                          <option v-for="(item, index) in departamentos" :value="item.codigo_departamento" :key="index">{{ item.nombre_departamento }}</option>
                        </select>
                    </div>
                  
                    <div class="col-12 col-md-4">
                      <label class="font-weight-bold mr-1">Municipio:</label>
                          <span
                            class="text-danger text-help"
                            v-if="!$v.empresa.id_municipio.required"
                            ><small>Campo requerido</small>
                          </span>
                          <select
                            class="custom-select"
                            :class="{'is-invalid':$v.empresa.id_municipio.$error}"
                            v-model="empresa.id_municipio"
                          >
                            <option
                              v-for="t in municipios"
                              :value="t.id_municipio"
                              :key="t.nombre_municipio"
                              >{{ t.nombre_municipio }}</option
                            >
                          </select>
                    </div>
                 
                    <div class="col-12 col-md-4">
                      <label class="font-weight-bold mr-1">Dirección:</label>
                        <span
                          class="text-danger text-help"
                          v-if="!$v.empresa.emp_direccion.required"
                          ><small>requerido</small>
                        </span>
                        <input
                          type="text"
                          placeholder="Ej.: Av. Ejercito"
                          class="form form-control"
                          :class="{'is-invalid':$v.empresa.emp_direccion.$error}"
                          v-model.trim="empresa.emp_direccion"
                          @keyup="empresa.emp_direccion = empresa.emp_direccion.toUpperCase()"
                        />
                    </div>                   
                  </div>

                  <div class="row">
                    <div class="col-12 col-md-12 form-group">
                      <label class="mr-1">Fotografía del frontis de la empresa:</label><br>  
                      <input type="file" id="file" ref="file" accept="image/*" @change="uploadImage($event)">
                    </div>
                    <div class="mx-auto text-center img-responsive">
                      <output id="list"></output>
                    </div>
                   
                  </div>
                      <div class="mx-auto text-center" v-if="!controBoton">
                      <output id="list"></output>
                      <img 
                        class="img-thumbnail text-center" 
                        width="275px" 
                        height="188px"
                        :src="'data:'+imagen.content+';base64,'+imagen.base64">
                    </div>
                   
                  <div class="row form-group">
                      <div class="col-12 col-md-12">
                          <div>
                       <l-map v-if="showMap" :zoom="zoomLapaz" :center="centerLapaz"
                        :options="mapOptionsLapaz" style="width: 100%; height: 360px"
                         @update:center="centerUpdate(empresa.emp_latitud, empresa.emp_longitud)" 
                         @update:zoom="zoomUpdate" @click="get_coordenadas">                      
                        <l-tile-layer :url="url" :attribution="attribution" /> 
                      
                          <l-marker :lat-lng="latlng(empresa.emp_latitud, empresa.emp_longitud)">  
                          <l-tooltip :options="{permanent:true, interactive:true}">
                           {{empresa.emp_razon_social}}
                           </l-tooltip>                       
                          </l-marker>                          
                      </l-map>
                    </div>

                       </div> 
                  </div>
                </div>
              </div>

              <div class="row ">
                <div class="col-md-4"></div>
                <div class="col-12 col-md-4"> 
                
                   <router-link :to="{ path: '/empresa/Empresas'}" class="btn btn-secondary btn-block">
                      Cancelar
                    </router-link>
                </div>
                <div class="col-12 col-md-4" > 
                  <button @click="updateEmpresa()" class="btn btn-primary btn-block">Actualizar</button>
                </div>
              </div>
             
            <!-- </form> -->
            </div>
          </div>
         
        </div>
    </div>

   
    <Loading v-show="cargando" />
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import Loading from "../../components/Loading";
//import moment from "moment";
//import GoogleMap from "../../components/GoogleMap";
import 'leaflet/dist/leaflet.css';
import { LMap, LTileLayer, LMarker, LTooltip} from "vue2-leaflet";
import { Icon, latLng  } from 'leaflet';
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
  name: "NuevoEmpresa",
  data() {
    return {
        id_empresa_obtenido:null,
       latitud:'',
      longitud:'',
      zoomobtenido:'',
      zoom: 5,
      zoomLapaz: 5,
      center: latLng(-16.290154,-63.588653),
      centerLapaz: latLng(-16.290154,-63.588653),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      withPopup: latLng(47.41322, -1.219482),
      withTooltip: latLng(47.41422, -1.250482),
      currentZoom: 11.5,
      currentCenter: latLng(-16.5157398,-68.1257891),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5
      },
       mapOptionsLapaz: {
        zoomSnap: 0.8
      },
      showMap: true,
      picked:true,
      picked1:false,
      empresas: [],
      empresa: {
        departamento: 'LPG',
        emp_latitud: 0,
        emp_longitud: 0
      },
      cargando: false,
      tituloModal: "Registro Empresa",
      departamentos: [],
      imagen: {
        base64: '',
        content: ''
      },
      municipios: [],
      rubros: [],
      
      persona: {},
      controBoton: true,
      departamento: ''
      //submitted: false,
    };
  },
  components: {
    Loading,
    //GoogleMap
     LMap,
    LTileLayer,
    LMarker,
    LTooltip,
  },
  methods: {

    latlng(lat, lng){
      return latLng(lat, lng);
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(lat, lng) {
      this.currentCenter = latLng(lat,lng);
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },


    get_coordenadas(e) {
      
      this.latitud = e.latlng.lat;
      this.longitud = e.latlng.lng;
      this.zoomobtenido=e.sourceTarget._zoom;
      //console.log(this.latitud,this.longitud);
    },
    async amEmpresa(item) {
      this.getDepartamentos();
      if (item == undefined) {
        this.empresa = {};
        // Valores por defecto
        this.empresa.codigo_departamento = 'LPG';
        this.getMunicipios('LPG');
        this.empresa.emp_latitud = -16.5157398;
        this.empresa.emp_longitud = -68.1257891;
        this.tituloModal = "NUEVO REGISTRO";
        this.controBoton = true;
      } else {
        // Arreglo para departamento
        let departamento = item.codigo_departamento;
        switch(departamento){
          case 'LPG':
            this.departamento = 'LA PAZ';
          break;
          case 'CBD':
            this.departamento = 'COCHABAMBA';
          break;
          case 'SCD':
            this.departamento = 'SANTA CRUZ';
          break;
          case 'ORD':
            this.departamento = 'ORURO';
          break;
          case 'PTD':
            this.departamento = 'POTOSI';
          break;
          case 'TJD':
            this.departamento = 'TARIJA';
          break;
          case 'CHD':
            this.departamento = 'CHUQUISACA';
          break;
          case 'BND':
            this.departamento = 'BENI';
          break;
          case 'PND':
            this.departamento = 'PANDO';
          break;
          default:
            this.departamento = 'LA PAZ'; 
          break;
        }

        this.empresa = item;
        this.empresa.emp_direccion;
        //carga ubicacion
        this.empresa.emp_latitud = Number(item.emp_latitud);
        this.empresa.emp_longitud = Number(item.emp_longitud);
        // Carga Imagen
        let imagen = item.nombre_imagen;
        let rutaImg  = await this.axios.get(`/imagenMostrar/frontis/${imagen}`);
        this.imagen.base64 = rutaImg.data.imagen;
        this.imagen.content = rutaImg.data.content;
        this.tituloModal = "EDITAR REGISTRO";
        this.controBoton = false;

        this.getMunicipios(this.empresa.codigo_departamento);
      }

      this.showModal();
    },
    async getDepartamentos() {
      try {
        let resultados = await this.axios.get(`/getDepartamentos`);
        this.departamentos = resultados.data.contenido;
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    async getMunicipios(par_cod_depto) {
      try {
        let resultados = await this.axios.get(`/getMunicipio/${par_cod_depto}`);
        this.municipios = resultados.data.contenido;
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    async getRubros() {
      try {
        let resultados = await this.axios.get(`/getRubros`);
        this.rubros = resultados.data.contenido;
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    async updateEmpresa() {
     this.empresa.emp_latitud = Number(this.latitud);
      this.empresa.emp_longitud = Number(this.longitud);

      try {
        let resultados = await this.axios.put(`/empresa`, this.empresa);
        //console.log("resultados:",resultados);
        this.empresa = resultados.data.contenido;
        let id = resultados.data.contenido.id_empresa;
        let config = {        
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        let formData = new FormData();
        formData.append('archivo', this.file);

        let res = await this.axios.put(`/upload/frontis/${id}`, formData, config);
       console.log(res);
       
        this.$swal({
          title: 'Información',
          text: 'Se Actualizo Correctamente!',
          type: 'success',
          confirmButtonText: 'Aceptar'
        });
     this.$router.push({ path: '/empresa/empresas'})
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    async listarDato() {
      let config = { headers: { token: this.token } };
      try {
        this.resultados = await this.axios.get(`/personaGetDataLogin`, config);
        this.persona = this.resultados.data.contenido;
        //console.log(this.persona);

        //this.getEmpresas(this.persona.id_persona);
      } catch (error) {
        console.log('catch: ', error);
      }
    },
     async getEmpresas(id_empresa_obtenido) {

      try {
        let resultados = await this.axios.get(`/empresaEditar/${id_empresa_obtenido}`);
        this.empresa = resultados.data.contenido;
        //this.getMunicipioObtenido(this.empresa.id_municipio);
        //this.carga_imagen(this.empresa.nombre_imagen);
         // Carga Imagen
      } catch (error) {
        console.log('catch: ', error);
      }
    },


    capturaCoordenadas (value){
     // console.log(value);
      this.empresa.emp_latitud= value.lat;
      this.empresa.emp_longitud= value.lng;
    },
  
    setPlace(event){
      //console.log(event);
      this.empresa.emp_latitud= event.geometry.location.lat();
      this.empresa.emp_longitud= event.geometry.location.lng(); 
      this.empresa.codigo_departamento = (event.address_components[3].long_name).toUpperCase() ;
    },

    async obtenerLugar (){
      let estaPos = await this.posicionNavegador();
      console.log(estaPos);
    },
    posicionNavegador (){
      if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function(position) {
            let pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
            //console.log('esta', pos);  
            return pos;   
          }, function() {
              //handleLocationError(true, infoWindow, map.getCenter());
          });
      } else {
          // Browser doesn't support Geolocation
          //handleLocationError(false, infoWindow, map.getCenter());
      }
    },
 

    uploadImage (evt){
      this.file = this.$refs.file.files[0];

      let files = evt.target.files; 
      for (let i = 0; i < files.length; i++) {
        let f = files[i];
        if (!f.type.match('image.*')) {
            continue;
        }
        let reader = new FileReader();
        reader.onload = (function(theFile) {
            return function(e) {
            document.getElementById("list").innerHTML = ['<img class="img-responsive img-thumbnail text-center" width="350px" height="250px" src="', e.target.result,'" title="', escape(theFile.name), '"/>'].join('');
            };
        })(f);
        reader.readAsDataURL(f);
      }
    },
   
  },

  async onChangeEmpresa(event){
      try {
        this.empresa.id_empresa = event.target.options[event.target.selectedIndex].value;
        this.empresa.nombre_empresa = (event.target.options[event.target.selectedIndex].text).split(' - ')[0];
        
        let resultado = await this.axios.get(`/getEmpresaDescripcion/${this.empresa.id_empresa}`);
        let datoEmpresa = resultado.data.contenido[0];
        
        // Carga Mapa
        this.empresa.direccion = datoEmpresa.emp_direccion;
        this.empresa.telefono = datoEmpresa.emp_telefono
        this.empresa.latitud = Number(datoEmpresa.emp_latitud);
        this.empresa.longitud = Number(datoEmpresa.emp_longitud);
        // Carga Imagen
        let imagen = datoEmpresa.nombre_imagen;
        let rutaImg  = await this.axios.get(`/imagenMostrar/frontis/${imagen}`);
        this.imagen.base64 = rutaImg.data.imagen;
        this.imagen.content = rutaImg.data.content;

      } catch (error) {
        console.log('catch: ', error);
      }
    },
    async onLoadImageDefault(){
      let rutaImg  = await this.axios.get(`/imagenMostrar/f/default`);
      this.imagen.base64 = rutaImg.data.imagen;
      this.imagen.content = rutaImg.data.content;
    },

  created() {
        this.id_empresa_obtenido=this.$route.params.id;
    this.listarDato();
    this.getDepartamentos();
    this.getRubros();
    this.getEmpresas(this.id_empresa_obtenido);
  },
  validations: {
    empresa: {
      emp_razon_social: { required },
      emp_nit: { required },
      emp_licencia: { required },
      emp_telefono: { required },
      codigo_departamento: { required },
      id_municipio: { required },
      emp_direccion: { required },
      id_rubro: { required },
      tipo_servicio: { required },
      emp_latitud: { required },
      emp_longitud: { required }
    },
  },
};
</script>
